export default {
	ADD_LEADER_REQUEST: 'ADD_LEADER_REQUEST',
	ADD_LEADER_SUCCESS: 'ADD_LEADER_SUCCESS',
	ADD_LEADER_FAILURE: 'ADD_LEADER_FAILURE',
	EDIT_LEADER_REQUEST: 'EDIT_LEADER_REQUEST',
	EDIT_LEADER_SUCCESS: 'EDIT_LEADER_SUCCESS',
	EDIT_LEADER_FAILURE: 'EDIT_LEADER_FAILURE',
	READ_LEADER_REQUEST: 'READ_LEADER_REQUEST',
	READ_LEADER_SUCCESS: 'READ_LEADER_SUCCESS',
	READ_LEADER_FAILURE: 'READ_LEADER_FAILURE',

	//CLUES
	ADD_ALIAS_REQUEST: 'ADD_ALIAS_REQUEST',
	ADD_ALIAS_SUCCESS: 'ADD_ALIAS_SUCCESS',
	ADD_ALIAS_FAILURE: 'ADD_ALIAS_FAILURE',
	EDIT_ALIAS_REQUEST: 'EDIT_ALIAS_REQUEST',
	EDIT_ALIAS_SUCCESS: 'EDIT_ALIAS_SUCCESS',
	EDIT_ALIAS_FAILURE: 'EDIT_ALIAS_FAILURE',
	BROWSE_ALIAS_REQUEST: 'BROWSE_ALIAS_REQUEST',
	BROWSE_ALIAS_SUCCESS: 'BROWSE_ALIAS_SUCCESS',
	BROWSE_ALIAS_FAILURE: 'BROWSE_ALIAS_FAILURE',
	REPORT_ALIAS_REQUEST: 'REPORT_ALIAS_REQUEST',
	REPORT_ALIAS_SUCCESS: 'REPORT_ALIAS_SUCCESS',
	REPORT_ALIAS_FAILURE: 'REPORT_ALIAS_FAILURE',
}